export const AWARD_VISIBILITIES = ['STAFF', 'PUBLIC'] as const;
export type AwardVisibility = (typeof AWARD_VISIBILITIES)[number];
